// src/components/Layout/PartnerRoute.jsx
//
// Auth guard for /partner-portal. Different from ProtectedRoute (which is
// for IN customer routes and enforces product-access + trial checks).
//
// PartnerRoute:
//   - Requires authentication (uses AuthContext, same bootstrap from ?auth=)
//   - Allows BOTH accountType: 'customer' and 'partner'
//     (a customer who's also enrolled as an affiliate uses the same portal)
//   - Skips all IN-specific trial / product / subscription guards because
//     a partner-only account has no subscription and no product access
//   - On not-authenticated, sends the visitor to the public sign-in page
//     (with a `go=partner-portal` flag so they're routed back after auth)

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const PartnerRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  const hasAuthParam = Boolean(
    new URLSearchParams(window.location.search).get('auth')
  );

  // Auth context is still hydrating (e.g. consuming a ?auth=... payload from
  // a fresh sign-in). Show a minimal loader so we don't bounce the user.
  if (loading || (hasAuthParam && !isAuthenticated)) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="w-10 h-10 border-4 border-indigo-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) {
    // Preserve the intent so after sign-in we drop them back here.
    return (
      <Navigate
        to={`/?view=signin&go=partner-portal${location.search ? `&from=${encodeURIComponent(location.pathname + location.search)}` : ''}`}
        replace
      />
    );
  }

  return children;
};

export default PartnerRoute;
